import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, ReactNode } from 'react';
import Close from '../../icons/Close';
import { cn } from '../../utils/cn';
import { Button } from '../_base/Button';

/** Props for a persistent status-driven notification card. */
export interface StatusToastProps extends Omit<ComponentProps<'article'>, 'title'> {
  toastId: string;
  title: string;
  description: ReactNode;
  icon: ReactNode;
  action?: ReactNode;
  /** Omit to render a toast the user can't dismiss. */
  onDismiss?: () => void;
}

/** Persistent notification card for status-driven prompts and actions. */
export function StatusToast(t0) {
  const $ = _c(41);
  let action;
  let className;
  let description;
  let icon;
  let onDismiss;
  let props;
  let title;
  let toastId;
  if ($[0] !== t0) {
    ({
      toastId,
      title,
      description,
      icon,
      action,
      onDismiss,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = action;
    $[2] = className;
    $[3] = description;
    $[4] = icon;
    $[5] = onDismiss;
    $[6] = props;
    $[7] = title;
    $[8] = toastId;
  } else {
    action = $[1];
    className = $[2];
    description = $[3];
    icon = $[4];
    onDismiss = $[5];
    props = $[6];
    title = $[7];
    toastId = $[8];
  }
  const titleId = `status-toast-${toastId}-title`;
  let t1;
  if ($[9] !== className) {
    t1 = cn("border-border p-md pointer-events-auto w-[min(360px,calc(100vw-32px))] rounded-[4px] border-[0.5px] bg-[color-mix(in_srgb,var(--color-popover)_84%,transparent)] shadow-lg backdrop-blur-[24px]", className);
    $[9] = className;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== icon) {
    t2 = <div className="mt-0.5 shrink-0" aria-hidden="true">{icon}</div>;
    $[11] = icon;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== title || $[14] !== titleId) {
    t3 = <p id={titleId} className="text-foreground text-sm leading-normal">{title}</p>;
    $[13] = title;
    $[14] = titleId;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== description) {
    t4 = <p className="text-secondary-foreground mt-2xs text-xs leading-normal">{description}</p>;
    $[16] = description;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t3 || $[19] !== t4) {
    t5 = <div className="min-w-0">{t3}{t4}</div>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== onDismiss || $[22] !== title || $[23] !== toastId) {
    t6 = onDismiss ? <Button variant="ghost" size="iconSm" aria-label={`Dismiss ${title}`} data-testid={`status-toast-dismiss-${toastId}`} className="text-secondary-foreground hover:text-foreground mt-[-2px] shrink-0" onClick={onDismiss}><Close /></Button> : null;
    $[21] = onDismiss;
    $[22] = title;
    $[23] = toastId;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6) {
    t7 = <div className="gap-sm flex items-start justify-between">{t5}{t6}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== action) {
    t8 = action ? <div className="mt-sm">{action}</div> : null;
    $[28] = action;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== t7 || $[31] !== t8) {
    t9 = <div className="min-w-0 flex-1">{t7}{t8}</div>;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t2 || $[34] !== t9) {
    t10 = <div className="gap-sm flex items-start">{t2}{t9}</div>;
    $[33] = t2;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== props || $[37] !== t1 || $[38] !== t10 || $[39] !== titleId) {
    t11 = <article {...props} role="group" aria-labelledby={titleId} className={t1}>{t10}</article>;
    $[36] = props;
    $[37] = t1;
    $[38] = t10;
    $[39] = titleId;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
}